const Minus = () => {
  return (
    <svg width="20" height="20" viewBox="0 0 20 20">
      <g fill="none" fillRule="evenodd">
        <g fill="#94A8BE" fillRule="nonzero">
          <g>
            <g>
              <path
                d="M10 0C4.477 0 0 4.477 0 10s4.477 10 10 10 10-4.477 10-10S15.523 0 10 0zm3 11H7c-.552 0-1-.448-1-1s.448-1 1-1h6c.552 0 1 .448 1 1s-.448 1-1 1z"
                transform="translate(-747 -551) translate(737 537) translate(10 14)"
              />
            </g>
          </g>
        </g>
      </g>
    </svg>
  );
};
export { Minus };
